import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

export const getOnboardingReport = async(param:any )=>{
   const response = await axiosInstance.get(`${API_ENDPOINTS.Reports.GET_ONBOARDING_REPORT}`,{params:param});
   const rowData = response?.data;
   const formatedData = Array.isArray(rowData?.data?.data)?
   rowData.data.data.map((item:any)=>({
     UnitName:item.UnitName,
     EmployeeCode:item.EmployeeCode,
     EmployeeName:item.EmployeeName,
     ZmManagerBranch:item.ZmManagerBranch,
     ZmManagerTown:item.ZmManagerTown,
     RmManagerBranch:item.RmManagerBranch,
     RmManagerTown:item.RmManagerTown,
     AmManagerBranch:item.AmManagerBranch,
     AmManagerTown:item.AmManagerTown,
     StownName:item.StownName,
     BeatName:item.BeatName,
     OutletTypeName:item.OutletTypeName,
     Descriptioin:item.Descriptioin
   })):[]
    
   return {formatedData,rowData};
}
   